const home = require('../content/pages/index');
const contact = require('../content/pages/contact');
const about = require('../content/pages/about');
const portfolio = require('../content/pages/portfolio');
const experiments = require('../content/pages/experiments');

module.exports = {
    siteTitle: 'Michel Comin', // Navigation and Site Title
    siteTitleAlt: 'Michel Comin - Portfolio', // Alternative Site title for SEO
    siteLogo: '/logos/logo-1024.png', // Used for SEO and manifest
    contact: {
        name: 'Contact',
        link:
            'mailto:michel.comin.escude@gmail.com?subject=Hello%20Michel!&amp;body=I%20just%20want%20to%20tell%20you%20that%20you%20are%20the%20best%20%3A).',
    },

    sn: {
        linkedin: {
            name: 'LinkedIn',
            link: '//linkedin.com/in/michelcomin',
        },
        twitter: {
            name: 'Twitter',
            link: '//twitter.com/mcx_sic',
        },
        instagram: {
            name: 'Instagram',
            link: '//www.instagram.com/mcx_sic/',
        },
        mindies: { name: 'Mindies', link: '//www.mindies.es' },
    },
    nav: {
        portfolio: {
            link: '/portfolio/',
            title: 'Portfolio',
        },
        about: {
            link: '/about/',
            title: 'About',
        },
        contact: {
            link: '/contact/',
            title: 'Contact',
        },
        home: {
            link: '/',
            title: 'Home',
        },
    },
    home,
    about,
    portfolio,
    experiments,
};



// WEBPACK FOOTER //
// ./content/copy.js